export const ORDERED_SHOWCASE_DESCRIPTION = "ordered";

export const shouldPreserveShowcaseOrder = (description) =>
  typeof description === "string" &&
  description.trim().toLowerCase() === ORDERED_SHOWCASE_DESCRIPTION;

const normalizePriority = (value) => {
  const priority = Number(value);
  return Number.isFinite(priority) ? priority : Number.MAX_SAFE_INTEGER;
};

const getItemContentKey = (item = {}) => {
  const content = item.content || item.contentMeta?.content || item;
  return (
    item.contentKey ||
    content.contentKey ||
    item.slug ||
    content.slug ||
    item._id ||
    content._id ||
    null
  );
};

export const orderShowcaseItemsByContentKeyPriority = (
  items = [],
  contentKeys = [],
) => {
  if (!Array.isArray(items)) return [];
  if (!Array.isArray(contentKeys) || contentKeys.length === 0) return items;

  const priorityByContentKey = new Map(
    contentKeys
      .filter(({ contentKey }) => contentKey)
      .map(({ contentKey, priority }) => [
        String(contentKey),
        normalizePriority(priority),
      ]),
  );

  if (priorityByContentKey.size === 0) return items;

  return items
    .map((item, index) => {
      const contentKey = getItemContentKey(item);
      const matchedPriority =
        contentKey && priorityByContentKey.has(String(contentKey))
          ? priorityByContentKey.get(String(contentKey))
          : Number.MAX_SAFE_INTEGER;

      return { item, index, priority: matchedPriority };
    })
    .sort((a, b) => a.priority - b.priority || a.index - b.index)
    .map(({ item }) => item);
};
